import styled from "@emotion/styled"
import {
	breakpoint,
	spacingFluidMd,
	spacingFluidXl,
	spacingStaticSm,
} from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"

export const ModelInformationSkeleton = () => (
	<Wrapper>
		<Skeleton.List entries={5} />
		<Skeleton.List entries={2} />
	</Wrapper>
)

const Wrapper = styled.div`
	display: grid;
	gap: ${spacingFluidMd} ${spacingStaticSm};

	@media (min-width: ${breakpoint.s}px) {
		column-gap: ${spacingFluidXl};
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
`
